import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { TGetProjectResponse } from "../types/projects";
import { TProject } from "@/zapi-frontend/stores/project";
import { AxiosResponse } from "axios";
import { useOrganizationStore } from "@/zapi-frontend/stores/organization";
import $api from "../api/axios";

export const GET_PROJECTS_LIST_KEY = "getProjectsList";

type TOptionsType = Partial<UseQueryOptions<AxiosResponse<{ data: TGetProjectResponse[] }>, Error, TProject[]>>;

export function useGetProjectsList(options?: TOptionsType) {
  const { currentOrganizationId } = useOrganizationStore();

  return useQuery({
    queryKey: [GET_PROJECTS_LIST_KEY, currentOrganizationId],
    queryFn: () => {
      return $api.get<{ data: TGetProjectResponse[] }>("/projects");
    },
    select: (response) =>
      response.data.data.map((project) => ({
        ...project,
        id: String(project.id),
        description: project.shortDescription
      })),
    ...options
  });
}
